<mode-encoding-pill-base
  [title]="errorMessage || tooltipQuickCalcDescription || displayName"
  [displayName]="displayName"
  [isValid]="isValid"
  [isAnalyticCalc]="isAnalyticCalc"
  [isDiscrete]="isDiscrete"
  [isContinuous]="isContinuous"
  [isDualAxis]="isDualAxis"
  [isSharedAxis]="isSharedAxis"
  [isDualAxisRelative]="isDualAxisRelative"
  [hideDualAxisAffordances]="isQuickChartType"
  [secondaryIcon]="sortDirectionIcon"
  secondaryIconClass="icon-sort"
  [errorMessage]="errorMessage"
  [caretIcon]="caretIcon"
  [contextMenu]="menu"
  [contextMenuSubject]="field"
  (showMenu)="showContextMenu($event)"
>
  <context-menu>
    <ng-container *ngIf="!hideAllMenuOptions">
      <ng-container *ngIf="hasDateFuncMenuOpts">
        <!-- Date Trunc Options -->
        <ng-template contextMenuItem [enabled]="false" [passive]="true">
          <span class="context-heading-item">
            <capra-icon class="continuous" icon="icon-field-date"></capra-icon>
            <span class="context-heading">Dates and Times</span>
          </span>
        </ng-template>
        <ng-container *ngFor="let dateTruncOpt of dateTruncOpts">
          <ng-template contextMenuItem (execute)="setDateTrunc(dateTruncOpt.unit)">
            <span [class.selected]="dateTruncOpt.isSelected"
              ><span class="indicator"></span><span class="context-link-name">{{ dateTruncOpt.label }}</span
              ><span class="context-link-aside">{{ dateTruncOpt.formatted }}</span></span
            >
          </ng-template>
        </ng-container>
        <ng-template contextMenuItem [subMenu]="dateTruncMoreMenu">More</ng-template>
        <context-menu #dateTruncMoreMenu>
          <ng-container *ngFor="let dateTruncOpt of dateTruncMoreOpts">
            <ng-template contextMenuItem (execute)="setDateTrunc(dateTruncOpt.unit)">
              <span [class.selected]="dateTruncOpt.isSelected"
                ><span class="indicator"></span><span class="context-link-name">{{ dateTruncOpt.label }}</span
                ><span class="context-link-aside">{{ dateTruncOpt.formatted }}</span></span
              >
            </ng-template>
          </ng-container>
        </context-menu>
        <ng-template contextMenuItem [divider]="true"></ng-template>

        <!-- Date Part Options -->
        <ng-template contextMenuItem [enabled]="false" [passive]="true">
          <span class="context-heading-item"
            ><capra-icon class="discrete" icon="icon-field-date"></capra-icon
            ><span class="context-heading">Date Parts</span></span
          >
        </ng-template>
        <ng-container *ngFor="let datePartOpt of datePartOpts">
          <ng-template contextMenuItem (execute)="setDatePart(datePartOpt.unit)">
            <span [class.selected]="datePartOpt.isSelected"
              ><span class="indicator"></span><span class="context-link-name">{{ datePartOpt.label }}</span
              ><span class="context-link-aside">{{ datePartOpt.formatted }}</span></span
            >
          </ng-template>
        </ng-container>
        <ng-template contextMenuItem [subMenu]="datePartMoreMenu">More</ng-template>
        <context-menu #datePartMoreMenu>
          <ng-container *ngFor="let datePartOpt of datePartMoreOpts">
            <ng-template contextMenuItem (execute)="setDatePart(datePartOpt.unit)">
              <span [class.selected]="datePartOpt.isSelected"
                ><span class="indicator"></span><span class="context-link-name">{{ datePartOpt.label }}</span
                ><span class="context-link-aside">{{ datePartOpt.formatted }}</span></span
              >
            </ng-template>
          </ng-container>
        </context-menu>
        <ng-template contextMenuItem [divider]="true"></ng-template>

        <!-- Start of year & Start of week-->
        <ng-template contextMenuItem [subMenu]="yearStartsMenu">Year start</ng-template>
        <context-menu #yearStartsMenu>
          <ng-container *ngFor="let ys of yearStartOptions">
            <ng-template contextMenuItem (execute)="setYearStart(ys.value)">
              <span [class.selected]="yearStart === ys.value">
                <span class="indicator"></span>
                <span class="context-link-name">{{ ys.name }}</span>
                <span
                  *ngIf="(isCustomCalenderSettingsEnabled$ | async) && defaultYearStart === ys.value"
                  class="context-link-aside"
                  >Org Default
                </span>
              </span>
            </ng-template>
          </ng-container>
        </context-menu>
        <ng-template contextMenuItem [subMenu]="weekStartsMenu">Week start</ng-template>
        <context-menu #weekStartsMenu>
          <ng-container *ngFor="let ws of weekStartOptions">
            <ng-template contextMenuItem (execute)="setWeekStart(ws.value)">
              <span [class.selected]="weekStart === ws.value">
                <span class="indicator"></span>
                <span class="context-link-name">{{ ws.name }}</span>
                <span
                  *ngIf="(isCustomCalenderSettingsEnabled$ | async) && defaultWeekStart === ws.value"
                  class="context-link-aside"
                  >Org Default
                </span>
              </span>
            </ng-template>
          </ng-container>
        </context-menu>
        <ng-template contextMenuItem [divider]="true"></ng-template>
      </ng-container>

      <!-- Exact Date/Time -->
      <ng-container *ngIf="hasExactDateTimeMenuOpt">
        <ng-template contextMenuItem (execute)="setAggregate(null)">
          <span [class.selected]="isExactDateAndTime"
            ><span class="indicator"></span><span class="context-link-name">Exact date and time</span></span
          >
        </ng-template>
        <ng-template contextMenuItem [divider]="true"></ng-template>
      </ng-container>

      <!-- No Aggregate -->
      <ng-template contextMenuItem [visible]="hasNoAggregateMenuOpt" (execute)="setAggregate(null)">
        <span [class.selected]="!aggFunc"
          ><span class="indicator"></span><span class="context-link-name">No aggregate</span></span
        >
      </ng-template>
      <ng-template contextMenuItem [visible]="hasNoAggregateMenuOpt" [divider]="true"></ng-template>

      <!-- Summable/Countable Aggregates -->
      <ng-container *ngFor="let aggrOpt of aggregateOpts">
        <ng-template contextMenuItem (execute)="setAggregate(aggrOpt.value)">
          <span [class.selected]="aggrOpt.value === aggFunc"
            ><span class="indicator"></span><span class="context-link-name">{{ aggrOpt.name }}</span></span
          >
        </ng-template>
      </ng-container>
      <ng-template contextMenuItem [visible]="aggregateOpts.length > 0" [divider]="true"></ng-template>

      <!-- Discrete/Continuous -->
      <ng-container *ngIf="hasVarTypeMenuOpts">
        <ng-template contextMenuItem (execute)="setVariableType(variableDiscrete)">
          <span [class.selected]="formula.isDiscrete"
            ><span class="indicator"></span><span class="context-link-name">Discrete</span></span
          >
        </ng-template>
        <ng-template contextMenuItem (execute)="setVariableType(variableContinuous)">
          <span [class.selected]="formula.isContinuous"
            ><span class="indicator"></span><span class="context-link-name">Continuous</span></span
          >
        </ng-template>
        <ng-template contextMenuItem [divider]="true"></ng-template>
      </ng-container>

      <!-- Bin -->
      <ng-container *ngIf="canBeBinned">
        <ng-template [enabled]="!disableBinningForValues" contextMenuItem (execute)="onToggleBin()">
          <span [class.selected]="isBinned">
            <capra-icon icon="icon-check" class="check-mark"></capra-icon>
            <span class="context-link-name">Bin</span>
          </span>
        </ng-template>

        <ng-template
          [enabled]="isBinned && !disableBinningForValues"
          contextMenuItem
          (execute)="onClickBinSettingsMenu()"
        >
          <span>
            <capra-icon icon="icon-check" class="check-mark"></capra-icon>
            <span class="context-link-name">Bin settings</span>
          </span>
        </ng-template>

        <ng-template contextMenuItem [divider]="true"></ng-template>
      </ng-container>

      <ng-container *ngIf="(isAggregateStage || isAnalyticCalc) && isMuzeRenderer">
        <!-- Quick Calc -->
        <ng-container *ngIf="isAggregateStage || hasAnalyticFunc">
          <ng-template contextMenuItem [subMenu]="quickCalc">Quick table calculation</ng-template>
          <context-menu #quickCalc>
            <ng-template contextMenuItem (execute)="setTrend(expressionPctDiff)">
              <span [class.selected]="formType === expressionPctDiff"
                ><span class="indicator"></span><span class="context-link-name">Percent difference</span></span
              >
            </ng-template>
            <ng-template contextMenuItem (execute)="setTrend(expressionDiff)">
              <span [class.selected]="formType === expressionDiff"
                ><span class="indicator"></span><span class="context-link-name">Difference</span></span
              >
            </ng-template>
            <ng-template contextMenuItem (execute)="setTrend(expressionPctOfTotal)">
              <span [class.selected]="formType === expressionPctOfTotal"
                ><span class="indicator"></span><span class="context-link-name">Percent of total</span></span
              >
            </ng-template>
            <ng-template contextMenuItem [divider]="true"></ng-template>
            <ng-template contextMenuItem [enabled]="formula?.hasAnalyticFunc" (execute)="setTrend(null)">
              <span class="context-link-name">Clear calculation</span>
            </ng-template>
          </context-menu>
        </ng-container>

        <!-- Table calc settings -->
        <ng-template contextMenuItem (execute)="openTableCalcSettings()">
          <span
            ><span class="indicator"></span><span class="context-link-name">Table calculation settings...</span></span
          >
        </ng-template>

        <ng-template contextMenuItem [divider]="true"></ng-template>
      </ng-container>

      <ng-container *ngIf="isVE">
        <!-- Shared Axis -->
        <ng-template contextMenuItem [visible]="canBeSharedAxis" (execute)="onToggleSharedAxis()">
          <span [class.selected]="isSharedAxis">
            <capra-icon icon="icon-check" class="check-mark"></capra-icon>
            <span class="context-link-name">Shared axis</span>
          </span>
        </ng-template>

        <!-- Dual Axis -->
        <ng-template contextMenuItem [visible]="hasDualAxisOpts && !isSharedAxis" (execute)="onToggleDualAxis()">
          <span [class.selected]="isDualAxis">
            <capra-icon icon="icon-check" class="check-mark"></capra-icon>
            <span class="context-link-name">Dual axis</span>
          </span>
        </ng-template>
      </ng-container>

      <!-- Split legend settings -->
      <ng-template contextMenuItem *ngIf="showColorSettings && isValues" (execute)="setLegendSplit(false)">
        <span
          class="split-legend-settings"
          [class.disabled]="!canLegendBeSplit"
          [class.selected]="!hasSplitLegend"
          capraTooltip
          tooltipPlacement="bottom"
          tooltipContent="Measure Names must be in the encoding to access these settings"
          [tooltipInteractive]="false"
          [tooltipDelay]="[500, 0]"
          [tooltipIsDisabled]="canLegendBeSplit"
        >
          <span class="indicator"></span>
          <span class="context-link context-link-name">Combined Legends</span>
        </span>
      </ng-template>

      <ng-template contextMenuItem *ngIf="showColorSettings && isValues" (execute)="setLegendSplit(true)">
        <span
          class="split-legend-settings"
          [class.disabled]="!canLegendBeSplit"
          [class.selected]="hasSplitLegend"
          capraTooltip
          tooltipPlacement="bottom"
          tooltipContent="Measure Names must be in the encoding to access these settings"
          [tooltipInteractive]="false"
          [tooltipDelay]="[500, 0]"
          [tooltipIsDisabled]="canLegendBeSplit"
        >
          <span class="indicator"></span>
          <span class="context-link context-link-name">Separate Legends</span>
        </span>
      </ng-template>

      <ng-template *ngIf="showColorSettings && isValues" contextMenuItem [divider]="true"></ng-template>

      <!-- Format -->
      <ng-container *ngIf="isMuzeRenderer">
        <ng-template *ngIf="!(isVegasPivotTable && isValues)" contextMenuItem (execute)="onAddSelectedFieldToFormat()">
          <span><span class="indicator"></span><span class="context-link-name">Format...</span></span>
        </ng-template>

        <!-- Sorting -->
        <ng-template contextMenuItem *ngIf="hasSortOpt" (execute)="doSort()">
          <span><span class="indicator"></span><span class="context-link-name">Sort...</span></span>
        </ng-template>
        <ng-template contextMenuItem *ngIf="hasClearSortOpt" (execute)="onRemoveSort()">
          <span><span class="indicator"></span><span class="context-link-name">Clear sort</span></span>
        </ng-template>

        <ng-template *ngIf="!(isVegasPivotTable && isValues)" contextMenuItem [divider]="true"></ng-template>
      </ng-container>
    </ng-container>

    <!-- Remove -->
    <ng-template contextMenuItem (execute)="removeField()">
      <span><span class="context-link-name">Remove</span></span>
    </ng-template>
  </context-menu>
</mode-encoding-pill-base>
